/**
 * ReceiverStep — receiver capture. Receivers are not required to be UPMP
 * customers, so we skip the lookup and accept free-form input.
 */
import type { JSX } from 'react';

import type { PartyPayload } from '../../lib/api/types';

import { PartyForm } from './PartyForm';
import { ReceiverSchema } from './validators/receiver.zod';

interface ReceiverStepProps {
  value: Partial<PartyPayload>;
  onChange: (next: Partial<PartyPayload>) => void;
  onContinue: () => void;
  onBack: () => void;
}

export function ReceiverStep({ value, onChange, onContinue, onBack }: ReceiverStepProps): JSX.Element {
  const result = ReceiverSchema.safeParse(value);
  const isValid = result.success;

  return (
    <section className="space-y-4" data-testid="receiver-step">
      <header>
        <h2 className="text-xl font-semibold text-slate-900">Receiver</h2>
        <p className="text-sm text-slate-600">
          Receivers don&apos;t need to be UPMP customers.
        </p>
      </header>

      <div className="rounded border border-slate-200 bg-white p-4">
        <PartyForm value={value} onChange={onChange} idPrefix="receiver" />
      </div>

      <div className="flex justify-between">
        <button
          type="button"
          onClick={onBack}
          className="rounded border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700"
        >
          Back
        </button>
        <button
          type="button"
          onClick={onContinue}
          disabled={!isValid}
          data-testid="receiver-continue"
          className="rounded bg-nipost-600 px-4 py-2 text-sm font-semibold text-white disabled:bg-slate-300"
        >
          Continue
        </button>
      </div>
    </section>
  );
}
